import ModalLayout from "../../layout/ModalLayout.tsx";
import NewApplicationForm from "../formik/NewApplicationForm.tsx";

export type ModalType = {
    show: boolean;
    onClose: () => void;
    data?: any
};
export default function NewApplicationModal({show, onClose, data}: ModalType) {
    return (
        <>
            {show && (
                <ModalLayout
                    title={"Add new application"}
                    text={"Add a new application to your project"}
                    onClose={onClose}
                >
                    <NewApplicationForm onClose={onClose} data={data}/>
                </ModalLayout>
            )}
        </>
    );
}
